import BeneficiariesTable from "./BeneficiariesTable"

export default BeneficiariesTable
